export const refs = {
  body: document.body,
};
